import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { MatchValidatorDirective } from '../../../../shared/validators/match.directive';
import { PasswordRecoveryStepsService } from '../../../services/password-recovery-steps.service';
import { ClientPasswordRecoveryTokenModel } from '../../../../shared/models/client-password-recovery-token.model';

@Component({
    selector: 'payment-identification-password-recovery-create-password',
    templateUrl: './payment.identification.password-recovery.create-password.component.html',
    styleUrls: ['../../../payment.component.scss'],
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: MatchValidatorDirective,
        multi: true
    }]
})
export class PaymentIdentificationPasswordRecoveryCreatePasswordComponent {
    public passModel = '';
    public passConfirmModel = '';
    public passSaveAttempts = 0;
    public confirmationCodeModel = '';
    public confirmationCodeValidated = false;
    public confirmationCodeValidateAttempts = 0;
    public loading = false;
    public invalid = false;
    @Output() savedNewPassword: EventEmitter<any> = new EventEmitter();
    @Output() validatedToken: EventEmitter<string> = new EventEmitter();
    @Output() refusedToken: EventEmitter<string> = new EventEmitter();
    @Output() skippedCreationProcess: EventEmitter<string> = new EventEmitter();
    @Input() email = '';

    constructor(
        protected passwordRecoveryService: PasswordRecoveryStepsService
    ) {
        this.resetError();
    }

    /**
     * Call API to save new password and emit savedNewPassword event if success.
     **/
    public savePassword() {
        this.loading = true;
        this.passwordRecoveryService.savePassword(
            this.passModel,
            this.confirmationCodeModel
        ).subscribe(() => {
            this.passSaveAttempts += 1;
            this.loading = false;
            this.savedNewPassword.emit(this.confirmationCodeModel);
        }, () => {
            this.passSaveAttempts += 1;
            this.loading = false;
        });
    }
    /**
     * Call API to validate inputted confirmation code.
     **/
    public validateConfirmationCode() {
        this.loading = true;
        this.resetError();
        this.passwordRecoveryService.validateToken(
            this.confirmationCodeModel,
            ClientPasswordRecoveryTokenModel.TYPE_NEW_PASSWORD_VERIFICATION_CODE
        ).subscribe(() => {
            this.confirmationCodeValidateAttempts += 1;
            this.loading = false;
            this.confirmationCodeValidated = true;
            this.validatedToken.emit(this.confirmationCodeModel);
        }, (err) => {
            this.invalid = true;
            this.confirmationCodeValidateAttempts += 1;
            this.loading = false;
            this.refusedToken.emit(err.hint);
        });
    }
    /**
     * Reset confirmationCodeValidateAttempts property.
     **/
    public resetConfirmationCodeValidateAttempts() {
        this.confirmationCodeValidateAttempts = 0;
        this.resetError();
    }
    /**
     * Skip password creation process and logging with token previously
     * inputted.
     **/
    public skip() {
        this.skippedCreationProcess.emit(this.confirmationCodeModel);
    }

    /**
     * This resets invalid property value to false.
     **/
    private resetError() {
        this.invalid = false;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/payment/identification/password-recovery/create-password/payment.identification.password-recovery.create-password.component.ts